module.exports = __webpack_public_path__ + "static/event_img1@2x-cd42d7b3d7c48fc3b7fb263480477265.png";